'use client';

import { ShowcaseSpinner } from '../../collection-showcase/scenes/playback-controls.jsx';
import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { ApprovalToggle } from './schedule-animation';
export function ApprovalCard({
  actions: e,
  enabled: t,
  decision: n,
  pressed: r,
  onToggle: i,
  onApprove: a,
  onDeny: o,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let s = n !== 'pending',
    c = e.filter((e) => t.has(e.key)),
    l = e.reduce((e, t) => e + t.count, 0),
    u = c.reduce((e, t) => e + t.count, 0),
    d = c.length === e.length;
  return (
    <div
      className={
        'enter w-full rounded-[12px] bg-[color-mix(in_oklch,var(--card)_70%,transparent)] px-2.5 py-4 shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--border)_70%,transparent),0_1px_2px_rgb(0_0_0/0.05)]'
      }
    >
      <div className={'px-1'}>
        <div className={'mb-2.5 px-1'}>
          <p className={'text-ink text-[14px] leading-snug font-semibold'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Send the counter-offer and update the store?'
            )}
          </p>
          <p className={'text-ink-3 mt-1 text-[12px] leading-relaxed'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Nothing goes out until you approve it.'
            )}
          </p>
        </div>
        <div className={'flex flex-col gap-1.5'}>
          {translateShowcaseNode(
            showcaseCopy,
            e.map((e) => {
              let r = t.has(e.key),
                a = n === 'approved' && r;
              return (
                <div
                  key={e.key}
                  className={`rounded-lg p-2.5 pr-1 transition-[background-color,box-shadow] duration-200 ${r ? 'bg-[color-mix(in_oklch,var(--primary)_5%,transparent)] shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--primary)_30%,transparent)]' : 'shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--border)_60%,transparent)]'}`}
                >
                  <div className={'flex items-center gap-2.5'}>
                    <span
                      className={
                        'text-ink grid size-7 shrink-0 place-items-center rounded-md bg-[var(--background)] shadow-[inset_0_0_0_1px_var(--border)]'
                      }
                    >
                      <ShowcaseIcon name={e.icon} className={'size-4'} />
                    </span>
                    <div className={'min-w-0 flex-1'}>
                      <div className={'flex flex-wrap items-center gap-1.5'}>
                        <span className={'text-ink text-[14px] font-medium'}>
                          {translateShowcaseNode(showcaseCopy, e.tool)}
                        </span>
                        <span
                          className={
                            'text-ink-2 rounded-md px-1.5 text-[11px] leading-5 shadow-[inset_0_0_0_1px_var(--border)]'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, e.kind)}
                        </span>
                        <span
                          className={
                            'text-ink-2 num rounded-md bg-[var(--secondary)] px-1.5 text-[11px] leading-5'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, '\xD7')}
                          {translateShowcaseNode(showcaseCopy, e.count)}
                        </span>
                      </div>
                      <p
                        className={
                          'text-ink-3 mt-0.5 text-[12px] leading-relaxed'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, e.detail)}
                      </p>
                    </div>
                    {translateShowcaseNode(
                      showcaseCopy,
                      a ? (
                        <span
                          className={
                            'grid h-10 w-11 shrink-0 place-items-center'
                          }
                        >
                          <span
                            className={
                              'bz-stamp grid size-6 place-items-center rounded-full bg-[var(--primary)] text-[var(--primary-foreground)]'
                            }
                          >
                            <ShowcaseIcon
                              name={'check'}
                              className={'size-3.5'}
                              strokeWidth={2.2}
                            />
                          </span>
                        </span>
                      ) : (
                        <ApprovalToggle
                          on={r}
                          label={`Allow ${e.tool}`}
                          disabled={s}
                          onToggle={() => i(e.key)}
                        />
                      )
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
        <p className={'mt-2.5 flex w-fit items-center gap-2 px-1'}>
          <span
            className={
              'size-4 rounded-[4px] shadow-[inset_0_0_0_1px_var(--border)]'
            }
          />
          <span className={'text-ink-3 text-[12px]'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Allow similar actions for the rest of this chat'
            )}
          </span>
        </p>
        <div
          className={
            'mt-3 flex flex-wrap items-center justify-between gap-2 px-1'
          }
        >
          <span
            className={'num text-ink-3 min-w-0 flex-1 truncate text-[12px]'}
          >
            {translateShowcaseNode(
              showcaseCopy,
              n === 'approved'
                ? `Approved · ${u} actions ran`
                : n === 'denied'
                  ? 'Not run \xB7 nothing was sent'
                  : d
                    ? `All ${l} actions allowed`
                    : `${u} of ${l} actions allowed`
            )}
          </span>
          <div
            className={`flex shrink-0 items-center gap-2 transition-opacity duration-200 ${n === 'approved' || n === 'denied' ? 'invisible opacity-0' : ''}`}
          >
            <button
              type={'button'}
              disabled={s}
              onClick={o}
              className={
                "press text-ink relative inline-flex h-8 items-center justify-center gap-1.5 rounded-md bg-[var(--background)] px-3 text-[12px] font-medium whitespace-nowrap shadow-[inset_0_0_0_1px_var(--border),0_1px_2px_rgb(0_0_0/0.05)] after:absolute after:-inset-1 after:content-[''] disabled:opacity-50"
              }
            >
              {translateShowcaseNode(showcaseCopy, 'Don\u2019t run')}
            </button>
            <button
              type={'button'}
              disabled={s || c.length === 0}
              onClick={a}
              className={
                "press relative inline-flex h-8 items-center justify-center gap-1.5 rounded-md bg-[var(--primary)] px-3 text-[12px] font-medium whitespace-nowrap text-[var(--primary-foreground)] after:absolute after:-inset-1 after:content-[''] disabled:opacity-50"
              }
              style={{
                transform: r ? 'scale(0.97)' : 'none',
              }}
            >
              {translateShowcaseNode(
                showcaseCopy,
                n === 'sending' ? (
                  <React.Fragment>
                    <ShowcaseSpinner className={'size-3'} />
                    {translateShowcaseNode(showcaseCopy, 'Sending')}
                  </React.Fragment>
                ) : d ? (
                  'Approve and run'
                ) : (
                  showcaseCopy['Approve {count} and run'].replace(
                    '{count}',
                    String(u)
                  )
                )
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export const ba =
  'Send the department store our counter-offer, and lower the price on three home pieces in the store.';
export const xa = [
  {
    key: 'email',
    tool: 'Email',
    icon: 'mail',
    kind: 'send',
    count: 1,
    detail:
      'To the department store buyer: 400 units at a 67% deposit, net 60.',
  },
  {
    key: 'store',
    tool: 'Store',
    icon: 'store',
    kind: 'update',
    count: 3,
    detail:
      'New prices for the stoneware candle, linen runner and cashmere throw.',
  },
];
export const Sa = [
  {
    label: 'Store',
    icon: 'store',
  },
  {
    label: 'Email',
    icon: 'mail',
  },
  {
    label: 'Social and ad accounts',
    icon: 'megaphone',
  },
  {
    label: 'Drives',
    icon: 'folder',
  },
  {
    label: 'CRM',
    icon: 'users',
  },
  {
    label: 'Design tools',
    icon: 'pen',
  },
];
export const Ca = {
  worked: 900,
  card: 1300,
  press: 4300,
  sending: 4450,
  approved: 5400,
};
export const wa = 7600;
export const Ta = {
  approved: [
    {
      id: 'sent',
      title: 'Email sent',
      meta: 'Department store buyer \xB7 counter-offer',
      icon: 'mail',
    },
    {
      id: 'store',
      title: 'Store updated',
      meta: '3 prices changed',
      icon: 'store',
    },
  ],
  denied: [
    {
      id: 'kept',
      title: 'Nothing was sent',
      meta: 'The drafts stay in the chat',
      icon: 'x',
    },
  ],
};
